export const NavLink_Data = [
    {
        exact: true,
        path: "/",
        label: "Home",
    },
    {
        exact: true,
        path: "/about",
        label: "About",
    },
    {
        exact: true,
        path: "/contact",
        label: "Contact",
    },
    {
        exact: true,
        path: "/login",
        label: "Login",
    },
];

export const NavLink_Data_Footer = [
    {
        exact: true,
        path: "/",
        label: "Home",
    },
    {
        exact: true,
        path: "/about",
        label: "About",
    },
    {
        exact: true,
        path: "/contact",
        label: "Contact",
    },
];

export const treatment = [
    {
        id: '121',
        title: 'SKIN CARE',
        description: 'The skin is the largest organ of the body. The skin protects us from microbes and helps to regulate body temperature, and permits the sensations of touch, heat, and cold.',
        subDescription: 'Now a days  skin related problems increasing tremendously due to busy life style such as lack of sleep, over stress , inadequate water intake, lack of exercise etc.',
        photoPath: '/Img/SkinCare.png',
        treatment_details: [
            {
                title: 'Acne (Pimples)',
                description: 'Skin condition in which , hair follicles become plugged with oil and dead skin cells.',
                subDescription: 'Most common in teenagers.',
                feature_Details: [
                    {
                        description: 'Orga Clean'
                    },
                    {
                        description: 'Classic Clean Facial.'
                    },
                    {
                        description: 'Signature Clean Facial.'
                    },
                    {
                        description: 'Acne Cure.'
                    },
                    {
                        description: 'Detoxifying Facial.'
                    },
                    {
                        description: 'Internal Medication.'
                    }
                ]
            },
            {
                title: 'Tanning & Hyper pigmentation',
                description: 'Whereby our skin color is darkened or tanned.',
                subDescription: 'It is a result of exposure to ultraviolet radiation. ',
                feature_Details: [
                    {
                        description: 'Signature Clean Facial.'
                    },
                    {
                        description: 'Destress Relaxig Facial.'
                    },
                    {
                        description: 'Rejuvinating-Njavara Facial.'
                    },
                    {
                        description: 'Organic Peels.'
                    },
                    {
                        description: 'Detan Packs.'
                    }
                ]
            },
            {
                title: 'Psoriasis ',
                description: 'Immune system attack healthy skin by mistake and affects entire life cycle of skin cells.',
                subDescription: 'Skin cells build up and form scales and itchy , dry patches.',
                feature_Details: [
                    {
                        description: 'Internal Medications.'
                    },
                    {
                        description: 'Dhara.'
                    },
                    {
                        description: 'Lapanam.'
                    }
                ]
            },
            {
                title: 'Dryness/Eczema',
                description: ' It is uncomfortable condition includes scaling , itching and cracking. ',
                subDescription: 'Exposure to dry weather, hot water , and certain chemicals causes skin to dry out.',
                feature_Details: [
                    {
                        description: 'Abynga (Oil Massage).'
                    },
                    {
                        description: 'Paraffing Therapy.'
                    },
                    {
                        description: 'Internal Medications.'
                    },
                    {
                        description: 'Customised Packs.'
                    }
                ]
            }
            ,
            {
                title: 'Open pores & Comedones.',
                description: 'Body contains millions of pores large looking pores due to high level of sebum production, reduce elasticity around the pores.',
                subDescription: 'Sun damage.',
                feature_Details: [
                    {
                        description: 'Orga Clean'
                    },
                    {
                        description: 'Classic Clean Facial.'
                    },
                    {
                        description: 'Signature Clean Facial.'
                    },
                    {
                        description: 'Micro Needling.'
                    },
                    {
                        description: 'Customised Packs.'
                    }
                ]
            },
            {
                title: 'Skin Tags or Warts',
                description: 'A common skin growth, Often on the neck, upper chest, under arms and eyelids.',
                subDescription: 'Usually harmless and painless.',
                feature_Details: [
                    {
                        description: 'Skin tag removal using cauterization.'
                    },
                    {
                        description: 'Internal medication boost up the skin immunity.'
                    }
                ]
            },
            {
                title: 'Melasma',
                description: 'Skin condition characterized by brown or blue-gray patches or freckle-like spots.',
                subDescription: 'It is often called the mask of pregnancy.',
                feature_Details: [
                    {
                        description: 'Customised antimelasma packs.'
                    },
                    {
                        description: 'Internal medications.'
                    },
                    {
                        description: 'Rejuvinating-Njavara Facial.'
                    },
                    {
                        description: 'Skin-tighting-energising facial.'
                    }
                ]
            }
        ]
    },
    {
        id: '122',
        title: 'HAIR CARE',
        description: 'Hair is one of the defining character of mammals and also a sensory apparatus. An average of 100000 of hair follicle present in the scalp. Each hair in the scalp grows in the different stages. ',
        subDescription: 'Average life span of a hair follicle is about 5-7 years and fall out , new hair grows in their place. We are providing the best treatment for different hair problems that  we are  facing today.',
        photoPath: '/Img/haircare.png',
        treatment_details: [
            {
                title: 'Hair loss & Hair Thinning.',
                description: 'Shedding of hair between 50-100 strands per day is normal.',
                subDescription: 'We lose our hair due to a lot of reasons like genetic, inadequate dietary supplements, lack of sleep, dehydration, diseases like fever, pcos, thyroid etc.',
                feature_Details: [
                    {
                        description: 'Siro abyngam.'
                    },
                    {
                        description: 'Kesha Dhoopanam.'
                    },
                    {
                        description: 'Nasyam.'
                    },
                    {
                        description: 'Thalapothichal.'
                    },
                    {
                        description: 'Jalouka avacharanam.'
                    },
                    {
                        description: 'Dermaroller.'
                    },
                    {
                        description: 'Inernal Medication and customised packs.'
                    }
                ]
            },
            {
                title: 'Alopecia areata (Patchy Hair loss).',
                description: 'It is autoimmune disorder.',
                subDescription: 'Sudden hair loss that starts with one or more circular bald patches that may overlap.',
                feature_Details: [
                    {
                        description: 'Siro abyngam.'
                    },
                    {
                        description: 'Lepanam.'
                    },
                    {
                        description: 'Nasyam.'
                    },
                    {
                        description: 'Jalouka avacharanam.'
                    },
                    {
                        description: 'Dermaroller.'
                    },
                    {
                        description: 'Internal Medication and customised packs.'
                    }
                ]
            },
            {
                title: 'Dandruff',
                description: 'Common condition that cause the skin on the scalp to flake.',
                subDescription: 'Skin flakes on the scalp , hair, eyebrows, beard or moustache and shoulders.',
                feature_Details: [
                    {
                        description: 'Siro udwarathanam.'
                    },
                    {
                        description: 'Siro dhara.'
                    },
                    {
                        description: 'Siro abyngam '
                    },
                    {
                        description: 'Internal Medication and customised packs.'
                    }
                ]
            },
            {
                title: 'Scalp Odour ',
                description: 'It could  be result of fungus, which cause inflammation like folliculitis, dandruff etc.',
                subDescription: 'It causes foul smelling scalp.',
                feature_Details: [
                    {
                        description: 'Kesha Dhoopanam'
                    },
                    {
                        description: 'Siro dhara.'
                    },
                    {
                        description: 'Siro abyngam '
                    },
                    {
                        description: 'Internal Medication and customised packs.'
                    }
                ]
            },
            {
                title: 'Premature Greying',
                description: 'Premature graying of hair (PGH) is   graying of hair in early age.',
                subDescription: 'It can severely affect the self-esteem of an individual.',
                feature_Details: [
                    {
                        description: 'Internal Medication and customised packs.'
                    },
                    {
                        description: 'Nasyam.'
                    },
                    {
                        description: 'Pada abyngam.'
                    }
                ]
            }
        ]
    },
    {
        id: '123',
        title: 'PAIN CARE',
        description: 'Pain is uncomfortable feeling. It can be associated with swelling, numbness , stiffness etc. Different types of diseases like low backache, joint problems, neck pain, headache, abdominal pain, internal organ pain etc.',
        subDescription: 'We are dealing with range of customized  treatments for pain management and their functionalities.',
        photoPath: '/Img/PainCare.png',
        treatment_details: [
            {
                title: 'Joint Pain',
                description: 'Joint pain is a very common problem with many possible causes, but its usually a result of injury or arthritis. Pain, swelling, stiffness etc are the normal symptoms of joint pain.',
                subDescription: 'The flu is one of the most well-known conditions that can cause body aches.',
                feature_Details: [
                    {
                        description: 'Internal Medication and customised packs.'
                    },
                    {
                        description: 'Dhara.'
                    },
                    {
                        description: 'Lepanam.'
                    },
                    {
                        description: 'Kizhi (Podi Kizhi, Manal Kizhi, Ela Kizhi.).'
                    },
                    {
                        description: 'Pichu.'
                    },
                    {
                        description: 'Bandage.'
                    }
                ]
            },
            {
                title: 'Back Pain',
                description: 'It can result from injury, activity and some medical conditions. It can affect people of any age, for different reasons.',
                subDescription: 'Back pain is a common reason for absence from work and for seeking medical treatment. It can be uncomfortable and debilitating.',
                feature_Details: [
                    {
                        description: 'Internal Medication and customised packs.'
                    },
                    {
                        description: 'Dhara.'
                    },
                    {
                        description: 'Lepanam.'
                    },
                    {
                        description: 'Kizhi (Podi Kizhi, Manal Kizhi, Ela Kizhi.).'
                    },
                    {
                        description: 'Pichu.'
                    },
                ]
            },
            {
                title: 'Head Ache',
                description: ' The most common types include: Tension Headaches. Tension headaches are the most common type of headache among adults and teens.',
                subDescription: 'They cause mild to moderate pain and come and go over time.',
                feature_Details: [
                    {
                        description: 'Internal Medication and customised packs.'
                    },
                    {
                        description: 'Dhara.'
                    },
                    {
                        description: 'Lepanam.'
                    },
                    {
                        description: 'Nasyam.'
                    },
                    {
                        description: 'Thalam..'
                    }
                ]
            }
        ]
    },
    {
        id: '124',
        title: 'WOMEN CARE',
        description: 'Specifically designed for women to provide traditional ayurvedic treatments for post natal care and  disorders like pcos, over weight , exccessive bleeding during menstruation etc.',
        subDescription: 'We are providing many formulation and treatment specially for women.',
        photoPath: '/Img/WomensCare.png',
        treatment_details: [
            {
                title: 'Post-Delivery Care',
                description: 'Specifically designed to provide internal and external traditional ayurvedic post delivery care',
                subDescription: 'It includes specila internal medication for agnideepanam, yonisodhanam, vatanulomanam and stanya jananam.',
                feature_Details: [
                    {
                        description: 'Internal Medication and customised packs.'
                    },
                    {
                        description: 'Abyngam.'
                    },
                    {
                        description: 'Vedhu Kuli.'
                    },
                    {
                        description: 'Dhara.'
                    },
                    {
                        description: 'Ela Kizhi.'
                    },
                    {
                        description: 'Podi Kizhi.'
                    }
                ]
            },
            {
                title: 'Pcos',
                description: 'It can result from injury, activity and some medical conditions. It can affect people of any age, for different reasons',
                subDescription: 'Common health condition that affects 8-13% of women of reproductive age.',
                feature_Details: [
                    {
                        description: 'Full body udwarthanam.'
                    },
                    {
                        description: 'Internal Medication.'
                    },
                    {
                        description: 'Exercise & Yoga.'
                    },
                    {
                        description: 'Diet & Nutritions..'
                    }
                ]
            },
            {
                title: 'Leukorrhea',
                description: 'It is a thick, whitish, yellowish or greenish vaginal discharge.',
                subDescription: 'There are many causes of leukorrhea, the usual one being estrogen imbalance.',
                feature_Details: [
                    {
                        description: 'Internal Medication.'
                    }
                ]
            }
        ]

    },
    {
        id: '125',
        title: 'DIET NUTRITION & YOGA',
        description: 'We are incorporating  these valuable treasure to each and every condition because it plays a big role in the health and wellness. And also for the body functionality nutritions needed.',
        subDescription: 'We are dealing with a wide range of customized  treatments for nutrition.',
        photoPath: '/Img/PainCare.png',
        treatment_details: [
            {
                title: 'Diet & Nutrition',
                description: 'Svattvic foods, the best way to nourish both mind and body.',
                subDescription: 'Ayurveda believes ahara is aushada.',
                feature_Details: [
                    {
                        description: 'After analyzing the prekrithi and needs, we are providing the correct diet plan to the patients.'
                    }
                ]
            },
            {
                title: 'Yoga',
                description: 'Yoga improves strength, balance and flexibility.',
                subDescription: 'Slow movements and deep breathing increases the blood flow.',
                feature_Details: [
                    {
                        description: 'We are providing yoga therapy for each and everyone.'
                    }
                ]
            }
        ]

    },
    {
        id: '126',
        title: 'GENERAL CARE',
        description: 'We provide all the basic treatments for  the diseases like fever, cough, asthma piles , varicose vein , diabetic etc. In a curative and preventive aspects.',
        subDescription: 'We are dealing wide range of customized  treatments for pain management and their functionalities.',
        photoPath: '/Img/GeneralCare.png',
        treatment_details: [
            {
                title: 'Athsma',
                description: 'Asma is a condition in which airways narrow and swell and may produce extra mucus.',
                subDescription: 'It can make breathing difficulty and coughing.',
                feature_Details: [
                    {
                        description: 'Internal medication.'
                    },
                    {
                        description: 'Breathing exercise.'
                    }
                ]
            },
            {
                title: 'Piles (Haemorrhoids)',
                description: 'Swollen and inflamed veins in the rectum and anus that cause discomfort and bleeding.',
                subDescription: 'Usually caused by strining during bowel movements, obesity or pregnancy.',
                feature_Details: [
                    {
                        description: 'Internal medication.'
                    },
                    {
                        description: 'Avagaham.'
                    }
                ]
            },
            {
                title: 'Vericos',
                description: 'Enlarged swollen and twisting veins, often appearing blue or dark purple in color.',
                subDescription: 'Commonly apprearing in legs and feet.',
                feature_Details: [
                    {
                        description: 'Internal medications.'
                    },
                    {
                        description: 'Jalouka Avacharanam.'
                    },
                    {
                        description: 'Lapanam.'
                    }
                ]
            },
            {
                title: 'Diabetic Mellitus',
                description: 'Metabolic disease that cause high blood sugar.',
                subDescription: 'In diabetics, body cells have become resistant to insulin.',
                feature_Details: [
                    {
                        description: 'Internal medications.'
                    },
                    {
                        description: 'Foot therapy.'
                    },
                    {
                        description: 'Diet, Nutrition and Yoga .'
                    }
                ]
            }
        ]
    },
];

export const about_Contact = [
    {
        name: 'Sachin Krishna',
        designation: 'CO-FOUNDER & ',
        designation2: 'MD',
        photoPath: './Img/SachinKrishna.jpg',
        facebookURL: '',
        twitterURL: '',
        instagramURL: 'https://instagram.com/_sachinkrishna?utm_medium=copy_link',
        whatsappURL: ''
    },
    {
        name: 'Dr. Divya Dileep',
        designation: 'CO-FOUNDER &',
        designation2: 'CEO',
        photoPath: './Img/Divya.jpg',
        facebookURL: '',
        twitterURL: '',
        whatsappURL: '',
        instagramURL: 'https://instagram.com/drdivyasachin?utm_medium=copy_link'
    }
]
export const about_Contact_special = {
    name: 'Dr. Divya Dileep',
    designation: 'Reg No. 16743 (TCMS)',
    designation2: 'BAMS, PGDCC, ILAMED',
    photoPath: './Img/Divya.jpg',
    instagramURL: 'https://instagram.com/drdivyasachin?utm_medium=copy_link',
    facebookURL: '',
    twitterURL: '',
    whatsappURL: '',
}
